import RedeemCodeInput from './redeem-code-input.component';

export default RedeemCodeInput;
